<article class="content-block-steps section-outset-y">
  <div class="container container-size-sm">
    <header class="text-max-width my-5">
      <h1 class="h2 pb-4">{{ block.title }}</h1>
      <div class="type-body-sm text-muted" *ngIf="block.text" [innerHTML]="block?.text"></div>
      <div class="mt-3" *ngIf="block?.button?.routerLink || block?.button?.url">
        <a class="button button--primary mt-4" [routerLink]="block.button.routerLink" *ngIf="block.button.routerLink">
          {{ block.button?.text }}
        </a>
        <a class="button button--primary mt-4" [href]="block.button.url" *ngIf="!block.button.routerLink">{{ block.button?.text }}</a>
      </div>
    </header>
    <main class="content-block-steps__main mt-3" *ngIf="block.steps">
      <ol class="content-block-steps__list">
        <li
          class="content-block-steps__list__item"
          [attr.data-id]="'Step-' + step.id"
          [class.set--current]="steps[i].active"
          *ngFor="let step of block.steps; let i = index"
        >
          <article class="steps-card">
            <h1 class="h4 steps-card__title mb-3">
              <button class="steps-card__button" (click)="openStep(step)">{{ step.title }}</button>
            </h1>
            <main class="steps-card__main d-md-flex">
              <div class="steps-card__text type-body-xs text-muted" [innerHTML]="step.text"></div>
              <figure class="steps-card__figure" *ngIf="step.imageUrl">
                <img [src]="step.imageUrl | resize: 600:undefined:step.imageAnchor" [alt]="step.title" />
              </figure>
            </main>
          </article>
        </li>
      </ol>
    </main>
  </div>
</article>
